/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BackfillProgress
 */
export interface BackfillProgress {
    /**
     * The installation ID.
     * @type {string}
     * @memberof BackfillProgress
     */
    installationId: string;
    /**
     * The object being synced (e.g., contact, account).
     * @type {string}
     * @memberof BackfillProgress
     */
    objectName: string;
    /**
     * The ID of the backfill operation.
     * @type {string}
     * @memberof BackfillProgress
     */
    operationId: string;
    /**
     * The number of records processed so far. Updates as more records are read during the backfill.
     * @type {number}
     * @memberof BackfillProgress
     */
    recordsProcessed: number;
    /**
     * The estimated total number of records to process. Only present for Salesforce and HubSpot; other connectors omit this field.
     * @type {number}
     * @memberof BackfillProgress
     */
    recordsEstimatedTotal?: number;
    /**
     * When the backfill operation started.
     * @type {Date}
     * @memberof BackfillProgress
     */
    createTime?: Date;
    /**
     * When progress was last updated.
     * @type {Date}
     * @memberof BackfillProgress
     */
    updateTime?: Date;
}

/**
 * Check if a given object implements the BackfillProgress interface.
 */
export function instanceOfBackfillProgress(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "installationId" in value;
    isInstance = isInstance && "objectName" in value;
    isInstance = isInstance && "operationId" in value;
    isInstance = isInstance && "recordsProcessed" in value;

    return isInstance;
}

export function BackfillProgressFromJSON(json: any): BackfillProgress {
    return BackfillProgressFromJSONTyped(json, false);
}

export function BackfillProgressFromJSONTyped(json: any, ignoreDiscriminator: boolean): BackfillProgress {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'installationId': json['installationId'],
        'objectName': json['objectName'],
        'operationId': json['operationId'],
        'recordsProcessed': json['recordsProcessed'],
        'recordsEstimatedTotal': !exists(json, 'recordsEstimatedTotal') ? undefined : json['recordsEstimatedTotal'],
        'createTime': !exists(json, 'createTime') ? undefined : (new Date(json['createTime'])),
        'updateTime': !exists(json, 'updateTime') ? undefined : (new Date(json['updateTime'])),
    };
}

export function BackfillProgressToJSON(value?: BackfillProgress | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'installationId': value.installationId,
        'objectName': value.objectName,
        'operationId': value.operationId,
        'recordsProcessed': value.recordsProcessed,
        'recordsEstimatedTotal': value.recordsEstimatedTotal,
        'createTime': value.createTime === undefined ? undefined : (value.createTime.toISOString()),
        'updateTime': value.updateTime === undefined ? undefined : (value.updateTime.toISOString()),
    };
}

